import { SectionProps } from "./Section.types";

import { Typography } from "shared/ui/components/Typography";

import styles from "./Section.module.scss";

const Section = ({ children, title }: SectionProps) => {
  return (
    <div className={styles.section}>
      <Typography variant="bodyM" className={styles.title}>
        {title}
      </Typography>
      <div className={styles.inner}>{children}</div>
    </div>
  );
};

export default Section;
